import { useState } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import PlayButton from '../Buttons/PlayButton/PlayButton';
import TrackWave from '../Tracks/TrackWave/TrackWave';

import { play, pause } from '../../store/actions';

import './GlobalPlayer.scss';

const GlobalPlayer = props => {


    return <div className='global-player-wrapper'>
        <Container className='global-player'>
            <Row>
                <Col className='track-container' lg="11" >
                    <TrackWave audioFile={props.player.track && props.player.track.file.url} playing={props.player.playing}
                    onPlaying={() => {}} />
                </Col>

                <Col className='playpause-container' lg="1">
                    <PlayButton playing={props.player.playing} onClick={() => props.player.playing ? props.pause() : props.play()} />
                </Col>
            </Row>
        </Container>
    </div>;
}

const mapStatetoProps = (state) => {
    return {
        player: state.Player
    };
};

const mapDispatchToProps = {
    play, pause
}

export default connect(mapStatetoProps, mapDispatchToProps)(GlobalPlayer);
